import {ApolloClient, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {AUTH_TOKEN} from "./constants";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

// const httpLink = createHttpLink({
const httpLink = createUploadLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`
});

const authLink = setContext((_, {headers}) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
}) //.concat(httpLink);

// const uploadLink = createUploadLink({uri: process.env.REACT_APP_GRAPHQL_URL});

// console.log(authLink, httpLink, concat(authLink, httpLink))

const client = new ApolloClient({
  // link: ApolloLink.from([authLink, httpLink, uploadLink]),
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

// const client = new ApolloClient({
//   link: authLink.concat(httpLink).concat(uploadLink),
//   cache: new InMemoryCache(),
// });

export default client;